import { render } from "./Listing.vue?vue&type=template&id=4ed6e388"
import script from "./Listing.vue?vue&type=script&lang=js"
export * from "./Listing.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/FeedbackSubject/Listing.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4ed6e388"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4ed6e388', __exports__)) {
    api.reload('4ed6e388', __exports__)
  }
  
  module.hot.accept("./Listing.vue?vue&type=template&id=4ed6e388", () => {
    api.rerender('4ed6e388', render)
  })

}


export default __exports__